import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import GlobalLoader from "@components/GlobalLoader";

import { getMyCompetitions } from "./competition.api";
import { errorMessage, formatDate } from "./competition.constants";
import { themeOf } from "./competition.theme";
import CompetitionBanner from "./CompetitionBanner";

import "./styles.scss";

const STATE_LABELS = {
  OPEN: "Bugünün sorusu açık",
  NOT_STARTED: "Yakında başlıyor",
  DONE: "Bugünün sorusunu yanıtladınız",
  CLOSED: "Bugün için sona erdi",
  NO_QUESTION: "Bugün soru yok",
};

/**
 * Kullanıcının hedef kitlesinde olduğu, süren yarışmalar. Tek yarışma varsa doğrudan
 * yarışma sayfasına geçilir.
 */
const Competitions = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    getMyCompetitions()
      .then((res) => {
        const list = res.data || [];
        if (list.length === 1) {
          navigate(`/competitions/${list[0].id}`, { replace: true });
          return;
        }
        setItems(list);
      })
      .catch((err) => {
        setError(errorMessage(err, "Yarışmalar yüklenemedi."));
        setItems([]);
      });
  }, [navigate]);

  return (
    <>
      <Header />
      {items === null ? (
        <GlobalLoader />
      ) : (
        <div className="cmp-list-page container py-5">
          <h1 className="cmp-list-title">Yarışmalar</h1>
          {error && <div className="cmp-error mb-3">{error}</div>}
          {!error && items.length === 0 && (
            <p className="cmp-list-empty">
              Şu anda katılabileceğiniz bir yarışma bulunmuyor.
            </p>
          )}
          <div className="cmp-list-grid">
            {items.map((item) => (
              <Link
                key={item.id}
                to={`/competitions/${item.id}`}
                className={`cmp-list-card ${themeOf(item).className}`}
              >
                {item.bannerImageUrl ? (
                  <CompetitionBanner competition={item} />
                ) : (
                  <div className="cmp-list-banner cmp-list-banner-fallback">
                    <span>{item.competitionTitle || item.name}</span>
                  </div>
                )}
                <div className="cmp-list-body">
                  <strong>{item.name}</strong>
                  <span className="cmp-list-dates">
                    {formatDate(item.dateBegin)} – {formatDate(item.dateEnd)}
                  </span>
                  {item.giftName && (
                    <span className="cmp-list-gift">🎁 {item.giftName}</span>
                  )}
                  {STATE_LABELS[item.todayState] && (
                    <span
                      className={`cmp-list-state cmp-list-state-${item.todayState}`}
                    >
                      {STATE_LABELS[item.todayState]}
                    </span>
                  )}
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}
      <Footer />
    </>
  );
};

export default Competitions;
